import { useTranslation } from 'react-i18next';

export default function TracksSection() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            {t('tracks.title')}
          </h2>
          <p className="text-lg text-gray-600 mb-10">
            {t('tracks.description')}
          </p>
          <a
            href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/documentos/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-2-line text-xl"></i>
            {t('tracks.button')}
          </a>
        </div>
      </div>
    </section>
  );
}
